import React, { FunctionComponent } from "react";
import { Header } from "../../../header";

type ClientQuestionsHeaderProps = {
    icon: string;
    clientHeading: string;
    children?: React.ReactNode;
};

const ClientQuestionsHeader: FunctionComponent<ClientQuestionsHeaderProps> = ({
    icon,
    clientHeading,
    children,
}) => (
    <div className="flex justify-between">
        <div className="header">
            <Header iconName={icon}>{clientHeading}</Header>
        </div>
        {children}
    </div>
);

export default ClientQuestionsHeader;
